import { jsx as _jsx } from "react/jsx-runtime";
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { z } from 'zod';
const SearchParamsSchema = z.object({
    name: z.string().optional()
}).passthrough();
export const Route = createFileRoute('/org/$organization/settings/teams')({
    validateSearch: (search)=>SearchParamsSchema.parse(search),
    component: ()=>/*#__PURE__*/ _jsx(Outlet, {})
});
